import React, {useContext, useState} from 'react';
import './ChangeHistory.scss';
import {I18nContext} from "../../contexts/i18nContext";
import {Button} from "../_common";
import {setUTCDate} from "../../helpers/helpers";

const ChangeHistory = ({ stateChangeHistory, changeLog, usersOptions }) => {
  const { t } = useContext(I18nContext);
  const [showHistory, setShowHistory] = useState(false);

  const toggleShowHistory = () => {
    setShowHistory(!showHistory);
  };

  const history = [...stateChangeHistory, ...changeLog].sort((a, b) => b.occurredAt?.localeCompare(a.occurredAt));

  return (
    <div className='ChangeHistory'>
      <Button
        label={!showHistory ? t('show change history') : t('hide change history')}
        action={toggleShowHistory}
      />
      {!!showHistory && (
        <>
          <div className='changesListHeader'>
            <div className='changeListHeaderItem'>
              {t('date of change')}
            </div>
            <div className='changeListHeaderItem'>
              {t('change type')}
            </div>
            <div className='changeListHeaderItem'>
              {t('change value')}
            </div>
            <div className='changeListHeaderItem'>
              {t('changed by')}
            </div>
            <div className='changeListHeaderItem'>
              {t('comment')}
            </div>
          </div>
          <div className='changesList'>
            {history.map((item, index) => (
              <div className='changeItem' key={index}>
                <div className='changeItemField'>
                  {item.occurredAt
                    ? new Date(setUTCDate(item.occurredAt)).toLocaleDateString('pl-PL') +
                      ' ' +
                      new Date(setUTCDate(item.occurredAt)).toLocaleTimeString('pl-PL')
                    : ''
                  }
                </div>
                <div className='changeItemField'>
                  {item?.projectState
                    ? t('project state')
                    : item?.dueDate
                      ? t('due date')
                      : item?.personResponsibleForTheProject
                        ? t('person responsible for the project')
                        : ''
                  }
                </div>
                <div className='changeItemField'>
                  {item?.projectState
                    ? t(item?.projectState)
                    : item?.dueDate
                      ? item?.dueDate
                      : item?.personResponsibleForTheProject && Array.isArray(item?.personResponsibleForTheProject)
                        ? item.personResponsibleForTheProject
                          .map(userId => usersOptions.find(x => x.id === userId).label)
                          .join(', ')
                        : item?.personResponsibleForTheProject
                          ? usersOptions.find(x => x.id === item.personResponsibleForTheProject).label
                          : ''
                  }
                </div>
                <div className='changeItemField'>
                  {item.userFirstName + " " + item.userLastName}
                </div>
                <div className='changeItemField'>
                  {item?.projectState
                    ? item.comment
                    : item?.dueDate
                      ? t('due date changed during project edition')
                      : item?.personResponsibleForTheProject
                        ? t('person responsible for project changed during project edition')
                        : ''
                  }
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ChangeHistory;
